import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Personnal from "./components/Personnal";
import Security from "./components/Security";
import { Col, Row } from "react-bootstrap";
import Billing from "./components/Billing";
import ITabs from "@components/ITabs";

const Home = (props) => {
  const { t } = useTranslation();
  const [ActiveButton, setActiveButton] = useState("personnal");
  const handleActiveButton = (value) => {
    setActiveButton(value);
  };

  const InputSection = ({ title, description, input }) => (
    <Row className="align-items-center my-3">
      <Col lg="6" className="my-2">
        <div className="fs-6 text-dark fw-medium">{title}</div>
        <p className="fw-light">{description}</p>
      </Col>
      <Col lg="6" className="my-2">
        {input}
      </Col>
    </Row>
  );

 const buttons = [
  {
    title: t("personnal_informations"),
    value: "personnal",
    icon: "user", // 👈 ADD THIS
    component: <Personnal {...props} InputSection={InputSection} t={t} />,
  },
  {
    title: t("connection_and_security"),
    value: "security",
    icon: "shield", // 👈 ADD THIS
    component: <Security {...props} InputSection={InputSection} t={t} />,
  },
  {
    title: t("billing_and_payment"),
    value: "billing",
    icon: "credit-card", // 👈 ADD THIS
    component: <Billing {...props} InputSection={InputSection} t={t} />,
  },
];

  return (
    <div
      className={`table-container p-4 bg-white rounded-4 shadow ${
        props.profile.mode === "dark" ? "text-white" : "text-dark"
      }`}
    >
     
      {/* <p className="my-1 fs-6 tetx-secondary fw-light">{t("settings_text")}</p> */}
      <section className="w-100 my-4">
        <ITabs navItems={buttons} container={"home-forms"} selected={0} />
      </section>
    </div>
  );
};

export default Home;
